import axios from 'axios'
import { camelizeKeys } from '../../helpers/utils'

import { getAuthHeaders } from '../../auth'
import { mockedClient } from '../util/mockedApiClient'

const DEFAULT_OPTIONS = {
  contentType: 'application/json',
  transformRequest: [
    function (data, headers) {
      Object.assign(headers, getAuthHeaders())
      return JSON.stringify(data)
    },
  ],
  transformResponse: [
    function (data) {
      // Convert JsonAPI's default kebab-case to camelCase for easier destructuring in Javascript
      let parsedData = null

      try {
        parsedData = camelizeKeys(JSON.parse(data))
      } catch (e) {
        console.warn('Failed to parse camelCase response data: ', e)
      }

      return parsedData || data
    },
  ],
}

// Temp solution until we can fix the busted `changeCaseObject` import in the actual apiClient
const apiClient = (baseURL, customerId, options) => {
  const inMockedDevMode = Boolean(process.env.REACT_APP_MOCKED_DEV_MODE)

  const settings = { ...DEFAULT_OPTIONS, ...options }
  const client = axios.create({
    baseURL,
    timeout: 30000,
    headers: {
      Accept: settings.contentType,
      'Content-Type': settings.contentType,
      'X-HB-CustomerId': customerId,
    },
    transformRequest: settings.transformRequest,
    transformResponse: settings.transformResponse,
  })

  return inMockedDevMode ? mockedClient() : client
}

export default apiClient
